import { getSizeProps, TAdFoxBannerTemplate } from '@cian/adfox-component';
import { Base64 } from 'js-base64';
import * as React from 'react';
import { isParsedParamsValid } from '../../../../utils/adfox';
import { useApplicationContext } from '../../../../utils/applicationContext';
import { IMediaBannerProps, MediaBanner, ITgbSuburbanProps, TgbSuburban } from '../../templates';
import styles from './OwnTemplates.css';

const OWN_BUNDLE_NAMES = ['banner.transfer'];
const OWN_TYPES: TAdFoxTemplateType[] = ['mainpageBrand', 'tgb_suburban'];

export type TAdFoxTemplateType = 'mainpageBrand' | 'tgb_suburban';

export interface IAdFoxTemplateParams {
  type: TAdFoxTemplateType;
  bgImageUrl: string;
}

export type TAdFoxTemplatesParams = IAdFoxTemplateParams & (IMediaBannerProps | ITgbSuburbanProps);

export const OwnTemplates: React.FC<TAdFoxBannerTemplate> = props => {
  const ctx = useApplicationContext();
  const { bundleName, bundleParams, containerId } = props;

  if (bundleName && OWN_BUNDLE_NAMES.includes(bundleName) && bundleParams) {
    if (bundleName === 'banner.transfer' && bundleParams.htmlBase64) {
      try {
        const decodedParams = Base64.decode(bundleParams.htmlBase64);
        const parsedDecodedParams = JSON.parse(decodedParams);

        if (isParsedParamsValid(parsedDecodedParams)) {
          if (OWN_TYPES.includes(parsedDecodedParams.type)) {
            switch (parsedDecodedParams.type) {
              case 'mainpageBrand':
                return <MediaBanner {...parsedDecodedParams} />;
              case 'tgb_suburban':
                return <TgbSuburban {...parsedDecodedParams} />;
            }
          }
        }
      } catch (e) {
        ctx.logger.error(e, {
          message: '[AdFox] Failed to decode/parse bundleParams',
          bannerId: bundleParams.bannerId,
        });
      }
    }
  }

  return <div id={containerId} className={styles['hidden']} style={getSizeProps(props)} />;
};
